import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  ssDialogService,
  vmSharedModelService
} from 'app/services';
import settingsDialog from './dialog.settingsDialog';
import controller from './settings.controller';
import directive from './settings.directive';


export default angular.module('app.components.advisory.vendorManagement.settings', [
  constants,
  loaderService,
  ssDialogService,
  vmSharedModelService,
  settingsDialog,
])
  .directive('vmSettings', directive)
  .controller('SettingsController', controller)
  .name;

console.log('app.components.advisory.vendorManagement.settings created');
